module.exports = __webpack_public_path__ + "img/11.039a0564.jpg";